import React from 'react';

function ThoughtJournal({ thoughtEntry, setThoughtEntry }) {
  return (
    <div className="card">
      <h2>Thought Journal</h2>
      <textarea
        placeholder="Write your thoughts..."
        value={thoughtEntry}
        onChange={(e) => setThoughtEntry(e.target.value)}
      />
      {thoughtEntry && (
        <p className="feedback">Saved Thought: {thoughtEntry}</p>
      )}
    </div>
  );
}

export default ThoughtJournal;
